import { render, staticRenderFns } from "./GarbageRemovalCategories.vue?vue&type=template&id=7f00bdbe&"
import script from "./GarbageRemovalCategories.vue?vue&type=script&lang=js&"
export * from "./GarbageRemovalCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports